import{gql as e}from"@apollo/client";const t=e`
  mutation deleteUsers($newUserStatus: EUserStatus!, $projectId: String!, $userIds: [Int]!) {
    user {
      deleteUsers: updateUsersStatus(newUserStatus: $newUserStatus, projectId: $projectId, userIds: $userIds)
    }
  }
`;export{t as DELETE_USERS_MUTATION};
//# sourceMappingURL=useDeleteUsers.graphql.js.map
